import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36041484&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./index.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./index.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js").rerender("36041484")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36041484')) {
      api.createRecord('36041484', component.options)
    } else {
      api.reload('36041484', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36041484&", function () {
      api.rerender('36041484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormComponents/BelongVehicles/index.vue"
export default component.exports